import { render, staticRenderFns } from "./TargetModal.vue?vue&type=template&id=a4981b60&scoped=true&"
import script from "./TargetModal.vue?vue&type=script&lang=js&"
export * from "./TargetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4981b60",
  null
  
)

export default component.exports